import React from 'react'
import ReactDOM from 'react-dom'
import RoomPageBase from './room-page-base'
import OrionsRevengeOnlineSchedule from 'frontend/pages/rooms/orions-revenge-online-schedule'
import moment from 'lib/moment-timezone-custom'

export default class OrionsRevengeOnlinePage extends RoomPageBase {
  static initSchedule () {
    const {
      roomId,
      openedFrom,
      prebookingCodeOnly
    } = document.body.dataset

    const root = document.getElementById('room_schedule_react')

    if (root) {
      ReactDOM.render(
        React.createElement(
          OrionsRevengeOnlineSchedule,
          {
            roomId: parseInt(roomId),
            openedFrom: openedFrom && moment(openedFrom),
            prebookingCodeOnly: prebookingCodeOnly !== undefined
          }
        ),
        root
      )
    } else {
      console.log(
        'OrionsRevengeOnlinePage.initSchedule()',
        'No #room_schedule_react element. Looks like booking not opened.'
      )
    }
  }

  static handleDOMReady () {
    super.handleDOMReady()
    this.initSchedule()
  }
}

OrionsRevengeOnlinePage.init()
